/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ client: NonNullable<unknown> }} Users_Form_Clients_RemoveInputs */

const en_users_form_clients_remove = /** @type {(inputs: Users_Form_Clients_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.client}`)
};

const pt_br2_users_form_clients_remove = /** @type {(inputs: Users_Form_Clients_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remover ${i?.client}`)
};

/**
* | output |
* | --- |
* | "Remove {client}" |
*
* @param {Users_Form_Clients_RemoveInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_form_clients_remove = /** @type {((inputs: Users_Form_Clients_RemoveInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Form_Clients_RemoveInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_form_clients_remove(inputs)
	return pt_br2_users_form_clients_remove(inputs)
});